'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    save: 'Save',
    send: 'Send',
    next: 'Next',
    prev: 'Previous',
    required: 'Required field',
    month: 'Month',
    monthYearError: 'Month and year are required',
    yearError: 'Year is required',
    monthError: 'Month is required',
    dayError: 'Day is required',
    dayYearError: 'Day and Year are required',
    dayMonthError: 'Day and month are required',
    add: 'Add',
    delete: 'Delete',
    cancel: 'Cancel',
    selectDate: 'Select date',
    selectMonth: 'Select month',
    minLength: 'The document cannot be saved, because the required number of characters is not entered!\nMin number of characters: {minLength}\nCharacters entered: {length}'
};